export default __webpack_public_path__ + "static/media/W51Bath2.4d9e6dd4.jpg";